<app-dialog
  [dialogType]="dialogType"
  [hideActions]="true"
  [hideCloseButton]="true"
  customClass="sending-dialog"
>
  <div id="sending-dialog">
    <img class="sending-img" src="assets/icons/sending.gif" />

    <span class="sending-text">
      {{ 'LABEL.SENDING' | translate }}
    </span>
  </div>
</app-dialog>
